<template>
  <div class="content modal-close-cont">
    <button class="btn close-modal border-radius-main bg-gray-l" @click="closeApp">
      <font-awesome-icon class="close-modal-icon h5" icon="times"/>
    </button>
  </div>
</template>

<script>

export default {
    name: 'etermin-close',
    methods: {
        closeApp: function () {
            this.$emit('closeApp')
        }
    }
}
</script>

<style lang="scss">
.modal-close-cont {
    top: -1rem;
    right: 0;
    transform: translateY(-100%);
}
</style>
